import type { TOC } from '@ember/component/template-only';
import SectionHeader from 'tio-reimagined/components/section-header';
import SmartActionCard from './smart-action-card';
import type { SmartAction } from './smart-action-card';
import { PhLightbulb } from 'ember-phosphor-icons';

export interface SmartActionsSectionSignature {
  Args: {
    /** Array of SmartAction items to render */
    actions: SmartAction[];
    /** Section title (default: "Recommended Actions") */
    title?: string;
    /** Section subtitle */
    subtitle?: string;
    /** Grid columns at md breakpoint: 2 or 3 (default: 3) */
    columns?: 2 | 3;
  };
  Element: HTMLElement;
}

/**
 * SmartActionsSection — encapsulates the repeated pattern of
 * SectionHeader + responsive grid + SmartActionCard loop.
 *
 * Used on documents, college-planning, idr, syf, wellness, and other pages.
 */
const SmartActionsSection: TOC<SmartActionsSectionSignature> = <template>
  <section ...attributes>
    <SectionHeader
      @icon={{PhLightbulb}}
      @title={{if @title @title "Recommended Actions"}}
      @subtitle={{@subtitle}}
      @iconClass="text-amber-500"
    />
    <div class="grid grid-cols-1 gap-4 {{if (isTwo @columns) 'md:grid-cols-2' 'md:grid-cols-3'}}">
      {{#each @actions as |smartAction|}}
        <SmartActionCard @item={{smartAction}} />
      {{/each}}
    </div>
  </section>
</template>;

function isTwo(columns: 2 | 3 | undefined): boolean {
  return columns === 2;
}

export default SmartActionsSection;
export { type SmartAction };
